import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_PUBLIC_SCHEDULE';

const eventPublicScheduleActions = {
  PUBLIC_SCHEDULE_STARTED: `${prefix}_PUBLIC_SCHEDULE_STARTED`,
  PUBLIC_SCHEDULE_SUCCESS: `${prefix}_PUBLIC_SCHEDULE_SUCCESS`,
  PUBLIC_SCHEDULE_ERROR: `${prefix}_PUBLIC_SCHEDULE_ERROR`,

  PUBLIC_SCHEDULE_ALL_STARTED: `${prefix}_PUBLIC_SCHEDULE_ALL_STARTED`,
  PUBLIC_SCHEDULE_ALL_SUCCESS: `${prefix}_PUBLIC_SCHEDULE_ALL_SUCCESS`,
  PUBLIC_SCHEDULE_ALL_ERROR: `${prefix}_PUBLIC_SCHEDULE_ALL_ERROR`,
  
  doPublicScheduleAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventPublicScheduleActions.PUBLIC_SCHEDULE_ALL_STARTED,
      });
    
      const result = await EventService.publicScheduleAll(ids);

      dispatch({
        type: eventPublicScheduleActions.PUBLIC_SCHEDULE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.publicScheduleAll.success', result.count),
      );
      
      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventPublicScheduleActions.PUBLIC_SCHEDULE_ALL_ERROR,
      });
    }
  },
};

export default eventPublicScheduleActions;
